<!-- 考试记录 -->
<template>
  <div>
    <div class="tab">
      <el-collapse v-model="activeNames">
        <el-collapse-item name="1">
          <el-form ref="form" :model="form" label-width="120px" size="mini">
            <el-row>
              <el-col :span="6">
                <el-form-item prop="fullName" label="姓名：">
                  <el-input size="small" v-model="form.fullName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="admissionCard" label="准考证号：">
                  <el-input
                    size="small"
                    v-model="form.admissionCard"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="phone" label="手机号：">
                  <el-input size="small" v-model="form.phone"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="6">
                <el-form-item prop="joinTime" label="加入时间：">
                  <el-date-picker
                    size="small"
                    v-model="form.joinTime"
                    type="datetimerange"
                    start-placeholder="开始日期"
                    range-separator="至"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :unlink-panels="true"
                    style="width: 100%"
                    class="datetime"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="mhmName" label="机构：">
                  <el-input size="small" v-model="form.mhmName"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <div class="btn" style="text-align: center">
              <el-row>
                <el-button type="primary" size="mini" @click="search">
                  确定
                </el-button>
                <el-button size="mini" @click="toggle">收起</el-button>
                <el-button size="mini" @click="delAll"> 清空 </el-button>
              </el-row>
            </div>
          </el-form>
        </el-collapse-item>
      </el-collapse>
      <div class="control">
        <el-button type="primary" @click="toggle">搜索</el-button>
      </div>
    </div>

    <el-table
      :data="tableData"
      style="width: 100%"
      size="small"
      :header-cell-style="{ 'background-color': '#e8eff9' }"
      @selection-change="handleSelectionChange"
      @sort-change="sortChange"
    >
      <el-table-column type="selection" width="50" align="center">
      </el-table-column>
      <el-table-column width="50" prop="ID" label="ID" align="center"></el-table-column>
      <el-table-column
        prop="fullName"
        label="试卷名"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="phone"
        label="用户名"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="admissionCard"
        label="成绩"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="joinTime"
        label="正确数"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="stuSource"
        label="错误数"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="alearyNum"
        label="考试时间"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="patrolNum"
        label="考试用时"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="openDate"
        label="更新时间"
        width="90"
        align="center"
        header-align="center"
      ></el-table-column>
      <el-table-column
        prop="uname"
        label="操作"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          <div class="table_control">
            <span class="table_control_item">详情</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageObj.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageObj.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import * as api from '@/api/TeacherClassroomManagement/MyClassroomTution/studentList'
export default {
  data() {
    return {
      batchId: this.$route.query.batchId,
      courseId: this.$route.query.courseId,
      activeNames: [],
      form: {
        fullName: '',
        admissionCard: '',
        phone: '',
        joinTime: [],
        mhmName: '',
      },
      tableData: [],
      // 分页
      pageObj: {
        page: 1,
        pageSize: 20,
      },
      // 总数
      total: 0,
      selectedList: [],
    }
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
    url() {
      let url = window.location.protocol + '//' + window.location.host
       if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      if (window.location.host == 'fxl.sce.scut.edu.cn') {
        url = url + '/zk'
      }
      return url
    },
  },
  created() {
    this.getStudentPage()
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.enterQuery)
  },
  methods: {
    async getStudentPage() {
      console.log('backd222t', this.$route.query.courseId)
      // console.log('backd222t', this.$route.query.batchId)
      const { fullName, admissionCard, phone, joinTime, mhmName } = this.form
      const [joinStartTime, joinEndTime] = joinTime
      const { data, code } = (
        await api.getStudentPage({
          batchId: this.batchId,
          courseId: this.courseId,
          courseTeacherId: this.getUId,
          fullName,
          admissionCard,
          phone,
          mhmName,
          joinStartTime,
          joinEndTime,
          ...this.pageObj,
        })
      ).data
      if (code === 100000) {
        this.tableData = data.list
        this.total = data.total
      }
    },

    //搜索的折叠面板
    toggle() {
      if (this.activeNames.length > 0) {
        this.activeNames = []
        window.removeEventListener('keyup', this.enterQuery)
      } else {
        this.activeNames = ['1']
        window.addEventListener('keyup', this.enterQuery)
      }
    },
    search() {
      this.pageObj.page = 1
      this.getStudentPage()
    },
    enterQuery(e) {
      if (e.key === 'Enter') {
        this.search()
      }
    },
    delAll() {
      this.$refs.form.resetFields();
      this.pageObj.page = 1
      this.getStudentPage()
    },
    addStudents() {
      this.$emit('addStudents')
    },
    // 改变页面接收数据大小
    handleSizeChange(val) {
      this.pageObj.pageSize = val
      this.getStudentPage()
    },

    // 改变当前页面
    handleCurrentChange(val) {
      this.pageObj.page = val
      this.getStudentPage()
    },
    visibleChange(e) {
      if (!e) {
        this.$refs.applyTypeSelect.blur()
      }
    },
    // 处理选中事件
    handleSelectionChange(arr) {
      this.selectedList = arr
    },
    goLearningOutcome() {
      this.$emit('goLearningOutcomeFromStudent')
    },
    sortChange({ column, prop, order }) {},
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/classManagement.scss';
.table_control {
  color: #409eff;
  .table_control_item {
    cursor: pointer;
  }
}
</style>
